import { Navigate, useRoutes } from 'react-router-dom';
// layouts
//
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import AuthClassicLayout from '../../layouts/auth/classic';
import LoginPage from '../../pages/auth/jwt/login';
// ----------------------------------------------------------------------

export default function Router() {
  const loginId = localStorage.getItem('loginId');
  const loginRoutes = [
    {
      path: '/',
      element: (
        <AuthClassicLayout>
          <LoginPage />
        </AuthClassicLayout>
      ),
    },
    {
      path: '/webwork',
      element: (
        <AuthClassicLayout>
          <LoginPage />
        </AuthClassicLayout>
      ),
    },

    ...authRoutes,
    ...mainRoutes,
    { path: '*', element: <Navigate to="/" replace /> },
  ];
  const dashboardRoutesConfig = [
    {
      path: '/',
      element: <Navigate to="/dashboard/work_request/home" />,
    },
    {
      path: '/dashboard',
      element: loginId !== null ? <Navigate to="/dashboard/work_request/home" /> : <Navigate to="/login" />,
    },
    ...dashboardRoutes,
    ...mainRoutes,
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  // Use the appropriate route configuration based on the value of 'vt'
  const routes = loginId !== null ? dashboardRoutesConfig : loginRoutes;

  return useRoutes(routes);
}
